import { ChevronRight, ExpandMore } from '@mui/icons-material';
import { TreeView } from '@mui/lab';
import { Box } from '@mui/material';
import { memo, useCallback } from 'react';
import TaxonomyNode from './TaxonomyNode';
import { treeViewStyles } from '../utils/styles';

function TaxonomyTree({
  treeData,
  selectedNodeId,
  setSelectedNodeId,
  expanded,
  setExpanded,
  handleAction,
  handleSaveFeature,
  levelMap,
  depth,
  maxDepth,
}) {
  const handleNodeSelect = useCallback(
    (nodeId) => {
      setSelectedNodeId(nodeId);
      setExpanded((prev) => (prev.includes(nodeId) ? prev : [...prev, nodeId]));
    },
    [setSelectedNodeId, setExpanded],
  );

  const handleToggle = useCallback(
    (_, nodeIds) => setExpanded(nodeIds),
    [setExpanded],
  );

  return (
    <Box sx={treeViewStyles.wrapper}>
      <TreeView
        defaultCollapseIcon={<ExpandMore />}
        defaultExpandIcon={<ChevronRight />}
        disableSelection
        onNodeToggle={handleToggle}
        expanded={expanded}
      >
        {treeData?.map((node) => (
          <TaxonomyNode
            key={node.id}
            node={node}
            selectedNodeId={selectedNodeId}
            handleNodeSelect={handleNodeSelect}
            handleAction={handleAction}
            handleSaveFeature={handleSaveFeature}
            levelMap={levelMap}
            depth={depth}
            maxDepth={maxDepth}
          />
        ))}
      </TreeView>
    </Box>
  );
}

export default memo(TaxonomyTree);
